/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equivalent weight (g/eq)`)
};

const es_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso equivalente (g/eq)`)
};

const de_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Äquivalentgewicht (g/eq)`)
};

const nl_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equivalentgewicht (g/eq)`)
};

const fr_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équivalent-gramme (g/éq)`)
};

const it_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso equivalente (g/eq)`)
};

const pt_br2_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso equivalente (g/eq)`)
};

const pt_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equivalente-grama (g/eq)`)
};

const ja_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量 (g/eq)`)
};

const zh_norm_field_ew = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量重量（g/eq）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_field_ew = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_field_ew(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_field_ew", locale)
	if (locale === "en") return en_norm_field_ew(inputs)
	if (locale === "es") return es_norm_field_ew(inputs)
	if (locale === "de") return de_norm_field_ew(inputs)
	if (locale === "nl") return nl_norm_field_ew(inputs)
	if (locale === "fr") return fr_norm_field_ew(inputs)
	if (locale === "it") return it_norm_field_ew(inputs)
	if (locale === "pt-BR") return pt_br2_norm_field_ew(inputs)
	if (locale === "pt") return pt_norm_field_ew(inputs)
	if (locale === "ja") return ja_norm_field_ew(inputs)
	return zh_norm_field_ew(inputs)
};